import { useRequest } from 'ahooks';
import { getNewestSearch } from '@axios/api'
import util from '../../../utils/utils';

function useGetNewestSearch(){
  const cacheKey = `newestSearch:${util.getCurrentClientId()}:${util.getUserId() || 'guest'}`;
  const { loading:newestSearchLoading, data, run } = useRequest(
    async () => {
      try {
        const clientId = util.getCurrentClientId();
        
        // ✅ a环境：确保有用户信息
        if (clientId === 'client-a') {
          util.ensureUserInfo();
        }
        
        // ✅ a环境视为已登录；b环境检查登录状态
        if (clientId !== 'client-a' && !util.isUserLoggedIn()) {
          return [];
        }

        // ✅ 添加用户ID参数
        const userId = util.getUserId();
        const params = userId ? { user_id: userId } : {};
      
        const resp = await getNewestSearch(params);
        return resp?.data?.newest_search_record ?? []
      } catch (error) {
        console.error('获取搜索历史失败:', error);
        return [];
      }
    },
    {          
      refreshDeps: [],
      debounceWait: 50,
      ready: true, // ✅ 总是准备就绪，在函数内部判断
      manual: false,
      // ✅ 缓存配置：10分钟
      cacheKey,
      staleTime: 10 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );
  
  const refresh = () => {
    const clientId = util.getCurrentClientId();
    
    if (clientId === 'client-a') {
      // a环境：确保用户信息并执行
      util.ensureUserInfo();
      run();
    } else if (util.isUserLoggedIn()) {
      // b环境：只有登录用户才允许刷新
      run();
    }
  };

  return {
    newestSearchLoading,
    newestSearchData: data || [], // 确保始终返回数组
    refresh
  }
}

export default useGetNewestSearch